import { Link } from "react-router-dom";
import { CAREERS_CONTENT } from "../data/company-content";
import { CompanyTabs } from "../components/CompanyTabs";
import SEO from "@/components/SEO";

export default function CompanyCareers() {
  return (
    <>
      <SEO
        title="Careers at Motosport Software | Automotive Platform"
        description="Explore careers at Motosport Software and help build a platform connecting buyers, dealers, and vehicle transactions into a unified workflow."
        url="https://motosportsoftware.com/company/careers"
      />
      <main className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
        <CompanyTabs currentTab="careers" />
        <div className="mt-6">
          <h2 className="mb-4 text-[30px] font-[800] leading-[36px] tracking-tight text-[#1F2A3A]">
            {CAREERS_CONTENT.title}
          </h2>
          {CAREERS_CONTENT.paragraphs.map((paragraph, index) => (
            <p key={index} className="mb-3.5 text-[15px] leading-[24px] text-[#525A68]">
              {paragraph}
            </p>
          ))}

          <div className="mt-2 rounded-[14px] bg-[#FCE8E4] p-4">
            <p className="text-[14px] font-[700] leading-[21px] text-[#7A2E25]">
              {CAREERS_CONTENT.notice}
            </p>
            <Link
              to="/contact"
              className="mt-2.5 inline-flex min-h-[44px] items-center text-[14px] font-[700] leading-[21px] text-[#BC0319] underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1F2A3A]"
            >
              In the meantime, reach out to us directly →
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}
